function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M586 115.2C465.6 104.8 61.4 70.1 25.3 67-16.8 63.4 6.4 88.2 6.4 88.2L239 321.7s16.6 20.6 39.5 6.9c15.3-9.4 38.2-23.5 64.6-39.8l87.1 44.5 63.7-137.6c49.7-30.7 88.8-54.8 93.6-57.8 14.2-8.8 19.6-20.8-1.5-22.7z"
});

function SvgPlaneShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 66.6 600 266.7"
  }, props), _ref);
}

export default SvgPlaneShadow;